import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['children'];

  toggleChildren() {
    this.element.parentElement.nextElementSibling.classList.toggle('is-hidden');
  }
}
